<template>
  <div id="GuestEditDialog_main">
    <el-dialog
      show-close
      width="60%"
      custom-class="GuestEditDialog_dialog"
      :title="title"
      :visible.sync="open"
      :before-close="beforeClose"
    >
      <el-form
        ref="guestEdit"
        :label-width="labelWidth"
        :model="form"
        label-position="left"
        :rules="editRules"
        @submit.native.prevent
      >
        <el-col
          :span="12"
          class="left-colum"
        >
          <el-form-item
            label="訪客事由"
            :inline="true"
            :required="causeRule.require"
            prop="cause"
          >
            <GuestCauseTypeSelect
              :guest-cause-list="guestCauseList"
              :def-cause="form.cause"
              @onChange="handleGuestCauseChange"
            />
          </el-form-item>

          <GuestNameGroup
            :is-required="householdRule.require"
            :guest-cause-list="guestCauseList"
            :guest-name-val="form.guestName"
            :guest-vendor-val="form.guestNameVendor"
            :clear="clear"
            :cause="form.cause"
            @onChange="handleGuestVendorChange"
          />

          <el-form-item
            label="手機號碼"
            prop="phone"
          >
            <el-input
              v-model="form.cellphone"
              maxlength="10"
              placeholder="請輸入"
              :clearable="true"
            />
          </el-form-item>
          <el-form-item
            label="車號"
            prop="licensePlateNumber"
          >
            <el-input
              v-model="form.licensePlateNumber"
              placeholder="請輸入"
              :clearable="true"
              maxlength="8"
              @input="checkForm('licensePlateNumber')"
            />
          </el-form-item>
        </el-col>
        <el-col
          :span="12"
          class="right-colum"
        >
          <el-form-item
            label="拜訪戶別"
            :label-width="leftLabelWidth"
            class="readonly-block"
          >
            {{ editData.tabletNote }}
          </el-form-item>

          <el-form-item
            label="預計抵達時間"
            :label-width="leftLabelWidth"
            prop="estimatedTimeOfArrival"
          >
            <el-date-picker
              v-model="form.estimatedTimeOfArrival"
              popper-class="el-date-picker__now-btn"
              type="datetime"
              placeholder="請選擇"
              :clearable="false"
              :picker-options="pickerOptions()"
              style="width: 100%;"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              @change="handleTimeChange"
              @input="handleTimeInput"
            />
          </el-form-item>

          <el-form-item
            label="備註"
            :label-width="leftLabelWidth"
          >
            <el-input
              v-model="form.memo"
              type="textarea"
              :rows="5"
              maxlength="30"
              placeholder="請輸入"
            />
          </el-form-item>
        </el-col>
        <!-- 這裡屆時看需不需要多判斷 && editData.qrCode 有無(目前應該僅有測試站資料會有需要),先不加入 -->
        <el-form-item
          v-if="qrCodeEnableApp"
          label-width="200px"
          label="門禁感應QR Code 有效時間"
        >
          <span class="time-content">{{ qrCodeTime.startAt }}</span>
          至
          <span class="time-content">{{ qrCodeTime.dueAt }}</span>
        </el-form-item>
      </el-form>
      <el-button
        round
        type="primary"
        :class="{ disabled: !isChangeForm }"
        :disabled="!isChangeForm"
        @click="validForm('guestEdit')"
      >
        完成修改
      </el-button>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import GuestCauseTypeSelect from '../components/GuestCauseTypeSelect.vue'
import GuestNameGroup from '../components/GuestNameGroup.vue'
import { isValidCellphone, isValidCellphoneNotContainZero } from '@/js/utils/unitValidate'
import { createBroadcastChannel } from '@/js/utils/broadcastChannelHelper'
import { formatLicensePlateNumber } from '@/js/utils/guest'

export default {
  components: {
    GuestCauseTypeSelect,
    GuestNameGroup
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    editData: { // 編輯項目
      type: Object,
      default: () => ({
        id: '', // 該筆登記 id
        cause: 0, // 訪客事由 id
        causeTypeName: '', // 訪客事由(字串名)
        guestName: '', // 訪客名稱
        guestNameVendor: '請選擇', // 廠商名稱
        cellphone: '', // 手機號碼
        licensePlateNumber: '', // 車號
        estimatedTimeOfArrival: '', // 預計抵達時間
        memo: '', // 備註
        tabletNote: '', // 拜訪戶別
        qrCode: null // QRcode 資訊
      })
    },
    guestCauseList: { // 訪客事由列表
      type: Array,
      default: () => []
    },
    qrCodeEnableApp: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const checkCause = (rule, value, callback) => {
      if (this.form.cause === 0) {
        callback(new Error('請選擇訪客事由'))
        return
      }

      callback()
    }
    const checkPhone = (rule, value, callback) => {
      // 限制只能輸入數字(若在 onkeyup 修改會造成輸入中文後 v-model 無法綁定值回來)
      this.form.cellphone = this.form.cellphone?.replace(/[^\d]/g, '')

      if (isValidCellphone(this.form.cellphone)) {
        callback()
      } else if (isValidCellphoneNotContainZero(this.form.cellphone)) {
        this.form.cellphone = `0${this.form.cellphone}`
        callback()
      } else if (this.form.cellphone === '') {
        callback()
      } else {
        callback(new Error('電話號碼格式錯誤'))
      }
    }
    const checkLicensePlateNumberRule = (rule, value, callback) => {
      const regex = /[^a-zA-Z0-9-]/

      if (this.form.licensePlateNumber) {
        if (regex.test(this.form.licensePlateNumber)) {
          callback(new Error('車號格式錯誤'))
          return
        }
      }

      callback()
    }
    const estimatedTimeRule = (rule, value, callback) => {
      const nowDay = dayjs()
      const choiceDay = dayjs(this.form.estimatedTimeOfArrival)

      // 不能小於當前時間
      if (choiceDay.isBefore(nowDay)) {
        callback(new Error('預計抵達時間已過期，請進行更新'))
        return
      }

      // 不能大於 當前登記時間+48hr
      if (choiceDay.isAfter(nowDay.add(48, 'h'))) {
        callback(new Error('僅能選擇 48 小時內的時間'))
        return
      }

      // 時間格式不正確
      if (!choiceDay.isValid()) {
        callback(new Error('時間格式錯誤'))
        return
      }

      callback()
    }

    return {
      title: '訪客登記資料修改',
      labelWidth: '137px',
      leftLabelWidth: '120px',
      clear: false,
      causeRule: { require: true },
      householdRule: { require: true },
      form: {
        id: '',
        cause: 0,
        causeTypeName: '',
        guestName: '',
        guestNameVendor: '請選擇',
        cellphone: '',
        licensePlateNumber: '',
        estimatedTimeOfArrival: dayjs().format('yyyy-MM-dd HH:mm'),
        memo: ''
      },
      qrCodeTime: {
        startAt: '--',
        dueAt: '--'
      },
      pickerOptions () {
        // 時間上限 當前時間 +48hr
        const maxDay = dayjs().add(48, 'h')

        // 最小時間 今天(需先減一天) 不能 < 今天
        const minDay = dayjs().subtract(1, 'day')

        // 當前時間
        const nowDay = dayjs()

        // 限制最小分秒 當前登記時間為主
        const choiceDay = dayjs(this.form.estimatedTimeOfArrival)

        let minuteTimeStr = '00:00:00 - 23:59:59'

        // 最大小時數
        if (choiceDay.format('YYYY/MM/DD') === maxDay.format('YYYY/MM/DD')) {
          const minuteTime = nowDay.format('HH:mm') // 當前時間 時 分界線
          minuteTimeStr = `00:00:00 - ${minuteTime}:00`
        }

        // 最小小時數
        if (choiceDay.format('YYYY/MM/DD') === dayjs().format('YYYY/MM/DD')) {
          const minuteTime = dayjs().add(1, 'minute').format('HH:mm') // 今日時間 時、分(+ 1分)做界線
          minuteTimeStr = `${minuteTime}:00 - 23:59:59`
        }

        return {
          disabledDate: (time) => {
            return dayjs(time).isAfter(maxDay) || dayjs(time).isBefore(minDay)
          },
          selectableRange: minuteTimeStr
        }
      },
      editRules: {
        cause: [
          { required: true, message: '請選擇訪客事由', trigger: 'change' },
          { validator: checkCause, trigger: 'change' }
        ],
        phone: { validator: checkPhone, trigger: 'change' },
        licensePlateNumber: { validator: checkLicensePlateNumberRule, trigger: 'change' },
        estimatedTimeOfArrival: [
          { required: true, message: '請選擇時間', trigger: 'change' },
          { validator: estimatedTimeRule, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    isChangeForm () {
      const isChangeGuestCause = this.findCaseId() !== this.form.cause
      const isChangeGuestName = this.getNowGuestName() !== this.editData.guestName
      const isChangeCellphone = this.form.cellphone !== this.editData.cellphone
      const isChangeLicensePlateNumber = this.form.licensePlateNumber !== this.editData.licensePlateNumber
      const isChangeEstimatedTimeOfArrival = !dayjs(this.form.estimatedTimeOfArrival).isSame(this.editData.estimatedTimeOfArrival)
      const isChangeMemo = this.form.memo !== this.editData.memo

      return (
        isChangeGuestName ||
        isChangeGuestCause ||
        isChangeCellphone ||
        isChangeLicensePlateNumber ||
        isChangeEstimatedTimeOfArrival ||
        isChangeMemo
      )
    }
  },
  watch: {
    open (value) {
      this.clear = !value

      if (!value) {
        this.formInit()
      }

      if (value) {
        // 預計抵達時間 初次進 dialog 需自行先調用驗證
        this.$nextTick(() => {
          this.$refs.guestEdit.validateField('estimatedTimeOfArrival')
        })
      }
    },
    editData () {
      this.form.cause = this.findCaseId()
      this.form.causeTypeName = this.editData.causeTypeName
      this.form.guestName = this.editData.guestName
      this.form.guestNameVendor = this.editData.guestNameVendor
      this.form.cellphone = this.editData.cellphone
      this.form.licensePlateNumber = this.editData.licensePlateNumber
      this.form.estimatedTimeOfArrival = this.editData.estimatedTimeOfArrival
      this.form.memo = this.editData.memo

      if (this.editData.qrCode) {
        this.qrCodeTime.startAt = dayjs(this.editData.qrCode.startAt).format('YYYY-MM-DD HH:mm')
        this.qrCodeTime.dueAt = dayjs(this.editData.qrCode.dueAt).format('YYYY-MM-DD HH:mm')
      }
    },
    causeTypeName () {
      this.form.case = this.findCaseId()
    }
  },
  methods: {
    formInit () {
      this.form = {
        id: '',
        cause: 0,
        causeTypeName: '',
        guestName: '',
        guestNameVendor: '請選擇',
        cellphone: '',
        licensePlateNumber: '',
        estimatedTimeOfArrival: dayjs().format('yyyy-MM-dd HH:mm'),
        memo: ''
      }
      this.qrCodeTime = {
        startAt: '--',
        dueAt: '--'
      }
    },
    findCaseId () {
      const defCause = this.guestCauseList
        .find((item) => item.Name === this.editData.causeTypeName)

      return defCause?.Id || 0
    },
    getNowGuestName () {
      let nowGuestName = this.form.guestName !== '' ? this.form.guestName : this.form.guestNameVendor
      nowGuestName = (nowGuestName === '請選擇' || !nowGuestName) ? '' : nowGuestName

      return nowGuestName
    },
    validGuestNameVendor () {
      const hasGuestName = this.form.guestName !== '' && this.form.guestName
      const hasGuestVendor = this.form.guestNameVendor !== '請選擇' && this.form.guestNameVendor

      return hasGuestName || hasGuestVendor
    },
    checkForm (item) {
      switch (item) {
      case 'licensePlateNumber':
        // 格式化車牌號碼
        this.form.licensePlateNumber = formatLicensePlateNumber(this.form.licensePlateNumber)
        break
      }
    },
    validForm (formName) {
      let errTxt = ''

      // 訪客/廠商名稱
      if (!this.validGuestNameVendor()) {
        errTxt = '請填寫「訪客／廠商名稱」'
      }

      if (this.getNowGuestName() && this.getNowGuestName().length < 2) {
        errTxt = '訪客 / 廠商名稱請輸入最少為 2 個字'
      }

      this.$refs[formName].validate((valid) => {
        if (valid && errTxt === '') {
          this.confirmEdit()
        } else {
          errTxt = errTxt || '訪客登記修改基本設定失敗 - 請確認各欄位均已填妥'

          this.$message({
            showClose: true,
            message: errTxt,
            type: 'warning'
          })
          return false
        }
      })
    },
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      if (!display) { loadingWrap.close() }
    },
    async handleEdit () {
      this.fullScreenLoading(true)
      const nowGuestName = this.getNowGuestName()
      const editData = {
        CauseTypeId: this.form.cause,
        GuestName: nowGuestName,
        CellPhone: this.form.cellphone,
        LicensePlateNumber: this.form.licensePlateNumber,
        EstimatedTimeOfArrival: dayjs(this.form.estimatedTimeOfArrival).toISOString(),
        Remark: this.form.memo
      }
      let isCanUpdate = false

      await apiGuest.PlusGuestReservation.PutEditBooked(
        { id: this.editData.id },
        editData,
        { 'content-type': 'application/json-patch+json' }
      ).then(async (res) => {
        this.$message({
          message: '訪客登記修改成功',
          type: 'success'
        })
        isCanUpdate = true
        const { postMessage, destroy } = createBroadcastChannel('guest')
        postMessage({ type: 'editItem', data: { id: this.editData.id, guestName: this.form.guestName } }) // 編輯推播項目
        postMessage({ type: 'reload' }) // 使其他頁面重新整理
        destroy()
      }).catch(err => {
        this.$message({
          message: '訪客登記修改失敗，請稍候再試',
          type: 'warning'
        })
      })

      // 變動時間 && 有開啟QRCode, 重新取得QRCode
      if (
        isCanUpdate &&
        !dayjs(this.editData.estimatedTimeOfArrival).isSame(dayjs(this.form.estimatedTimeOfArrival)) &&
        this.qrCodeEnableApp
      ) {
        try {
          await this.requireQRCode()
        } catch (err) {
          // catch 給後方&更新列表及關閉loading
        }
      }

      if (isCanUpdate) {
        // 更新列表
        this.$emit('onEditFinish')
      }

      this.fullScreenLoading(false)
    },
    confirmEdit () {
      this.$confirm('是否確定修改訪客登記？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleEdit()
      }).catch(() => {
      })
    },
    beforeClose () {
      this.$emit('onClose')

      // 清空資料
      this.$refs.guestEdit.resetFields()
      this.qrCodeTime = {
        startAt: '--',
        dueAt: '--'
      }
    },
    handleGuestCauseChange (changeValue) {
      this.form.cause = changeValue
      this.form.guestNameVendor = '請選擇'
    },
    handleGuestVendorChange ({ guestName, guestVendor }) {
      this.form.guestName = guestName
      this.form.guestNameVendor = guestVendor
    },
    handleTimeInput (value) {
      // 如果選擇了今日,自動將分秒換成當前+1分(因設置format會默認為00:00:00)
      if (dayjs(value).format('YYYY/MM/DD') === dayjs().format('YYYY/MM/DD')) {
        if (dayjs(value).isBefore(dayjs())) {
          this.form.estimatedTimeOfArrival = new Date(dayjs().add(1, 'minute').format('YYYY/MM/DD HH:mm'))
        }
      }
    },
    async handleTimeChange (value) {
      const newQRCodeTime = this.getTranslateFormTime(new Date(value))

      // QRcode 預算有效時間為前後30分
      this.qrCodeTime.startAt = dayjs(newQRCodeTime).subtract(30, 'm').format('YYYY-MM-DD HH:mm')
      this.qrCodeTime.dueAt = dayjs(newQRCodeTime).add(30, 'm').format('YYYY-MM-DD HH:mm')
    },
    async requireQRCode () {
      // 重新取得QRCode
      const time = await this.getSendQRcodeTime(new Date(this.form.estimatedTimeOfArrival))
      const queryPath = {
        id: this.editData.id
      }

      // ！！注意這邊，回傳給後端的 start due 時間，需要捨棄時區影響（須為現在時間的8小時前）
      const requestData = {
        startAt: `${time.startAt.replace(' ', 'T')}.000Z`,
        dueAt: `${time.dueAt.replace(' ', 'T')}.000Z`
      }
      await this.postCreateQRcode(queryPath, requestData)
    },
    getTranslateFormTime (time = new Date()) {
      // 取得指定時間，5分鐘一個級距，去掉秒數無條件進位，並回傳加減30分鐘
      const now = time
      let nowData = ''

      if (now.getMinutes() % 5 === 0) {
        nowData = `${this.$newFormatDate(now).slice(0, 17) + '00'}`
      } else {
        const interval = parseInt(now.getMinutes() / 5) + 1
        const min = interval * 5
        if (min === 60) { // 56-60分時，進位到下一個小時
          const now2 = now.getTime() + 5 * 60 * 1000
          nowData = `${this.$newFormatDate(now2).slice(0, 14) + '00:00'}`
        } else {
          nowData = `${this.$newFormatDate(now).slice(0, 14) + (('0' + (min)).slice(-2)) + ':00'}`
        }
      }

      return nowData
    },
    getSendQRcodeTime (time = new Date()) {
      return new Promise((resolve) => {
        const nowData = this.getTranslateFormTime(time)

        const nowLongData = new Date(nowData).getTime()
        const newTime = {
          startAt: this.$newFormatDate(nowLongData - 30 * 60 * 1000 - 8 * 60 * 60 * 1000),
          dueAt: this.$newFormatDate(nowLongData + 30 * 60 * 1000 - 8 * 60 * 60 * 1000)
        }

        resolve(newTime)
      })
    },
    // 取得新的QRCode
    postCreateQRcode (queryPath, requestData) {
      return new Promise((resolve, reject) => {
        apiGuest.PlusGuestReservation.PostCreateQRcode(
          queryPath,
          requestData
        ).then((res) => {
          resolve()
          if (res.status !== 200) {
            this.$message.error('更新QRCode失敗，請稍後再試')
          }
        }).catch((err) => {
          reject(err)
          // 無卡機戶別無法更新QR code
          if (err.response.data === 'QrCode is null') {
            this.$message.error('訪客登記修改失敗，沒有該戶別資料')
            return
          }

          this.$message.error('訪客登記修改失敗，請稍後再試')
        })
      })
    }
  }
}
</script>

<style lang="sass" scoped>
#GuestEditDialog_main
  ::v-deep .el-dialog
    &.GuestEditDialog_dialog
      +basicDialog
      .el-form
        .el-form-item__label
          margin-right: 0px
      .readonly-block
        text-align: left
      .left-colum
        padding-right: 15px
      .right-colum
        padding-left: 15px
      .el-button.disabled
        opacity: 0.3
        cursor: default

.invalid__border
  ::v-deep .el-input__inner
    border: $dangerColorHover 1px solid

.time-content
  font-weight: bold
  color: #5f5f5f
  font-size: 22px
  padding: 0 6px
</style>
